import { type CardBlockingReason } from 'modules/physical-cards/card';

function isCardBlocked(
  userId: string,
  cardBlockingReason?: CardBlockingReason,
) {
  return (
    cardBlockingReason &&
    (cardBlockingReason.initiator !== 'user' ||
      (cardBlockingReason.initiator === 'user' &&
        cardBlockingReason.userId !== userId))
  );
}

export type CardBlockingReasonAccess = {
  hasAccess: boolean;
  initiator?: CardBlockingReason['initiator'];
};

export function getCardAccess(
  userId: string,
  cardBlockingReason?: CardBlockingReason,
): CardBlockingReasonAccess {
  let cardsAccess: {
    hasAccess: boolean;
    initiator?: CardBlockingReason['initiator'];
  } = {
    hasAccess: true,
  };
  if (cardBlockingReason && isCardBlocked(userId, cardBlockingReason)) {
    cardsAccess = {
      hasAccess: false,
      initiator: cardBlockingReason.initiator,
    };
  }

  return cardsAccess;
}
